// extracted by mini-css-extract-plugin
module.exports = {"root":"DistributedTeams_root__OqCX7","ui":"DistributedTeams_ui__LNk_1"};